import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from '@/services/ApiBase';
import { AjaxService } from '@/services/Ajax.service';

export class NewsletterV2Service extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/newsletter');

  async subscribeToNewsletter({ email, storeId }: {email: string; storeId: string}): Promise<void> {
    try {
      return await this.api.getPromisedJSON(`${NewsletterV2Service.baseUrl}?email=${encodeURIComponent(email)}&storeId=${storeId}`);
    } catch (error) {
      throw new Error('Error');
    }
  }
}

export class FakeNewsletterService extends ApiBase {
  constructor(api?: AjaxService) {
    super(api);
  }

  public success: boolean = false;
  public timeoutValue: number = 0;

  async subscribeToNewsletter({ email, storeId } : {email: string; storeId: string}): Promise<void> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!email || !storeId || this.success === false) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject();
        } else {
          resolve();
        }
      }, this.timeoutValue);
    });
  }
}
